import { DoubleArrow, UpArrow, DownArrow } from 'ui/icons';
import { noop } from 'utils/noop';
import { HeaderButton } from '../WorkflowWebhookIndexTable.styles';
import { SORT_DIRECTIONS } from '../constants';

// type Props = {
//   /** Label to display in column header */
//   label: string,
//   /** Unique id for this column */
//   id: string,
//   /** Current sort direction */
//   sortDirection: ASCENDING | DESCENDING,
//   /** Function run when sort direction is changed */
//   onSortDirectionChange: (ASCENDING | DESCENDING) => {},
//   /** Function run when sortBy value is changed */
//   onSortByChange: (newSortedById: string) => {},
//   /** True if column is sortable */
//   isSortable: boolean,
//   /** True if column is active sort column  */
//   isActiveSortColumn: boolean,
// };

export const TableHeaderButton = ({
  label,
  id,
  sortDirection,
  onSortDirectionChange = noop,
  onSortByChange = noop,
  isSortable = false,
  isActiveSortColumn = false,
  ...props
}) => {
  const { ASCENDING, DESCENDING } = SORT_DIRECTIONS;
  const isAscending = sortDirection === ASCENDING;
  return (
    <HeaderButton
      data-test={`column-header-${id}`}
      key={id}
      onClick={() => {
        if (isActiveSortColumn) {
          onSortDirectionChange(isAscending ? DESCENDING : ASCENDING);
        } else {
          onSortByChange(id);
          onSortDirectionChange(DESCENDING);
        }
      }}
      {...props}
    >
      <span>{label}</span>
      {isSortable && !isActiveSortColumn && <DoubleArrow />}
      {isSortable && isActiveSortColumn && isAscending && <UpArrow />}
      {isSortable && isActiveSortColumn && !isAscending && <DownArrow />}
    </HeaderButton>
  );
};
